import { RequestStatus } from "../constants/RequestStatus";

interface RequestStatusState {
  requestStatus: RequestStatus;
}

interface RequestStatusAction {
  type: RequestStatus;
}

export const initialRequestStatus: RequestStatusState = Object.freeze({
  requestStatus: RequestStatus.PENDING,
});

export const requestStatusReducer = (
  state: RequestStatusState = initialRequestStatus,
  action: RequestStatusAction
): RequestStatusState => {
  switch (action.type) {
    case RequestStatus.SUCCESS:
    case RequestStatus.FAILED:
    case RequestStatus.PENDING:
      return {
        ...state,
        requestStatus: action.type,
      };
    default:
      return state;
  }
};
